import { render, staticRenderFns } from "./AppRelease.vue?vue&type=template&id=07797eee&scoped=true&"
import script from "./AppRelease.vue?vue&type=script&lang=js&"
export * from "./AppRelease.vue?vue&type=script&lang=js&"
import style0 from "../SalesForce.scss?vue&type=style&index=0&id=07797eee&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07797eee",
  null
  
)

export default component.exports